import { pickBy, isNull, isUndefined, isObject, isEmpty, keys } from 'lodash-es';

export function extractNonEmptyKeys(data: any) {
  const filtered = pickBy(data, (value) => {
    return !(isNull(value) || isUndefined(value) || (isObject(value) && isEmpty(value)));
  });

  return keys(filtered);
}
